import { render, staticRenderFns } from "./CertificationEnrol.vue?vue&type=template&id=0657f385&scoped=true&"
import script from "./CertificationEnrol.vue?vue&type=script&lang=js&"
export * from "./CertificationEnrol.vue?vue&type=script&lang=js&"
import style0 from "./CertificationEnrol.vue?vue&type=style&index=0&id=0657f385&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0657f385",
  null
  
)

export default component.exports